import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { installMfaChallengeInterceptor } from './services/mfaChallenge'

// Notice MFA enrollment challenges on EVERY request, not just the ones
// that happen to go through a service wrapper. Observes only - it never
// alters a response or throws, so existing error handling is unaffected.
installMfaChallengeInterceptor()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
